import { BaseFetch } from "../main-model"
export default class ReportCommanBudYearModel extends BaseFetch {
    getReportCommanBudYearBy = (data) =>
    this.authFetch({
      url: "report-comman-bud-year/getReportCommanBudYearBy",
      method: "POST",
      body: JSON.stringify(data),
    })
}
